import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConstants } from '../common/global-constants';
import { lastValueFrom } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CarritoService {
  Url: string;
  constructor(public http: HttpClient) {
    this.Url = GlobalConstants.apiURL;
    ;
  }


  public addCarProd(DatosCar: any) {
    let json = JSON.stringify(DatosCar);
    let params = json;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return lastValueFrom(this.http.post(this.Url + '/addCarProd', params, { headers: headers }));
  }

  public async getCarProd(IdUsuario: number) {
    let params = new HttpParams().set("IdUsuario", IdUsuario);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return await lastValueFrom(this.http.get(this.Url + '/getCarrito', { params }));
  }

  public async deleteCarProd(DatosCar: any) {
    let json = JSON.stringify(DatosCar);
    let params = json;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return await lastValueFrom(this.http.post(this.Url + '/deleteCarrito', params, { headers: headers }));
  }
}
